export default __webpack_public_path__ + "static/media/Top3.098784ee.svg";